namespace TabAurous.Common {
    export interface GetLineNoResponse extends Serenity.ServiceResponse {
        Line_No?: number;
    }
}
